import React from 'react';
import { TouchableOpacity } from 'react-native';

import { TextPropTypes } from 'deprecated-react-native-prop-types';
import { isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import { useTheme } from '../Themes';
import VFText from '../VFText';

import styles from './VFShowMoreText.Styles';
import ViewMoreText from './ViewMoreText';

const onPress = (handlePress, onShowMoreToggle, isExpanded) => {
  _isFunction(onShowMoreToggle) && onShowMoreToggle(isExpanded);
  handlePress();
};
function VFShowMoreText({
  text,
  showMoreText,
  showLessText,
  numberOfLines,
  onShowMoreToggle,
  renderContent,
  style,
}) {
  const theme = useTheme();

  const renderShowMore = handlePress => {
    return (
      <>
        {_isFunction(renderContent) ? renderContent(false) : null}
        <TouchableOpacity onPress={onPress.bind(null, handlePress, onShowMoreToggle, true)}>
          <VFText
            style={[styles.showText(theme), styles.showMoreText(numberOfLines)]}
            i18nKey={showMoreText}
          />
        </TouchableOpacity>
      </>
    );
  };
  const renderShowLess = handlePress => {
    return (
      <>
        {_isFunction(renderContent) ? renderContent(true) : null}
        <TouchableOpacity onPress={onPress.bind(null, handlePress, onShowMoreToggle, false)}>
          <VFText style={styles.showText(theme)} i18nKey={showLessText} />
        </TouchableOpacity>
      </>
    );
  };
  return (
    <ViewMoreText
      numberOfLines={numberOfLines}
      renderViewMore={renderShowMore}
      renderViewLess={renderShowLess}
    >
      <VFText i18nKey={text} style={[styles.descriptionText, style]} />
    </ViewMoreText>
  );
}

VFShowMoreText.propTypes = {
  text: PropTypes.string,
  showMoreText: PropTypes.string,
  showLessText: PropTypes.string,
  numberOfLines: PropTypes.number,
  onShowMoreToggle: PropTypes.func,
  renderContent: PropTypes.func,
  style: TextPropTypes.style,
};
export default VFShowMoreText;
